import React from 'react';
import * as PropTypes from 'prop-types';
import { ReactComponent as FilesIcon } from './images/files-icon.svg';
import styles from './DropZone.module.scss';

const DropZonePlaceholder = ({ title }) => (
  <div className={styles.placeholder}>
    {title && <span className={styles.placeholderTitle}>{title}</span>}
    <FilesIcon className={styles.icon} />
  </div>
);

DropZonePlaceholder.propTypes = {
  title: PropTypes.string,
};

export default DropZonePlaceholder;
